import React from 'react';

export const Cards = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
      <path d="M4.96143 7.63635H15.1431" stroke="currentColor" strokeWidth="1.5" />
      <path d="M11.3242 10.1818H13.2333" stroke="currentColor" />
      <path
        d="M15.1431 5.09094V12.7272H4.96143V5.09094H15.1431Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11.3243 3.18189V1.27283H1.14258L1.14258 8.90909H3.05165"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};
